export default "__VITE_ASSET__82fbf056__"